import { call, put, takeLatest } from 'redux-saga/effects'

import {
  postFarmUser,
  putFarmUser,
  deleteFarmUser
} from '@galo-monitor/services/apis/galoMonitorApi/resources/user'

import { FarmUserActions, FarmUserTypes } from './duckFarmUser'

function* saveFarmUser({
  farmUser,
  onSuccess = () => {},
  onError = () => {}
}) {
  try {
    yield call(farmUser.id ? putFarmUser : postFarmUser, farmUser)

    yield call(onSuccess)
  } catch (err) {
    yield put(FarmUserActions.farmUserError(err.message))
    yield call(onError, err)
  }
}

function* removeFarmUser({ farmUser, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deleteFarmUser, farmUser)
    yield call(onSuccess)
  } catch (err) {
    yield put(FarmUserActions.farmUserError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(FarmUserTypes.SAVE_FARM_USER, saveFarmUser),
  takeLatest(FarmUserTypes.REMOVE_FARM_USER, removeFarmUser)
]
